/* This function returns the value of obj.key
Examples:
field: foo ---------- key: foo
field: foos[0] ---------- key: foos.0
field: foos[0].bar ---------- key: foos.0.bar
*/
export const getField = function ({obj, key, defaultValue}) {
	if (obj && key) {
		const value = key.split(".").reduce(function (o, x) {
			return typeof o == "undefined" || o === null ? o : o[x]
		}, obj)
		if (value) {
			return value
		}
	}
	return defaultValue
}
